module.exports = "https://static.wmbcdn.com/uniweb/images/2d8a4a883be8cea30c09b50a63fc86f3.svg";